<div class="main" *spaceContext="'main'">
  <app-base-nav-bar />

  <div class="under-nav-bar">
    <app-split-view
      side="left"
      key="adminSidebar"
      [collapsedSize]="76"
      [shadow]="true"
      [magneticSize]="120"
      [withIcon]="true"
    >
      <div class="sidebar" split-left-pane>
        <app-admin-side-bar />
      </div>

      <div split-right-pane class="content">
        <router-outlet *stchSpaceRerender />
      </div>
    </app-split-view>
  </div>
</div>
